import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.email || !form.password) return toast.error("Email aur password dono zaroori hain");
    setLoading(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Khush aamdeed, ${user.username}!`);
      nav("/");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login nahi hua");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md border border-[#2A2A2D] bg-[#121214] p-10">
        <div className="overline text-[#B79C7B] mb-3">ShiaTunes</div>
        <h1 className="font-serif text-3xl text-ivory">Login karein</h1>
        <p className="text-sm text-[#A1A1AA] mt-2">
          Account nahi hai?{" "}
          <Link to="/register" className="text-[#B79C7B] hover:underline">Register karein</Link>
        </p>

        <form onSubmit={onSubmit} className="mt-8 space-y-4">
          <input
            type="email"
            placeholder="Email"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="w-full h-12 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory"
          />
          <input
            type="password"
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="w-full h-12 bg-[#0A0A0B] border border-[#2A2A2D] focus:border-[#B79C7B] outline-none px-4 text-ivory"
          />
          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 bg-[#8A2E2E] hover:bg-[#A33B3B] transition-colors text-sm tracking-widest disabled:opacity-50"
          >
            {loading ? "..." : "LOGIN"}
          </button>
        </form>
      </div>
    </div>
  );
}
